module.exports = __webpack_public_path__ + "img/products.e7304dfa.svg";